import { useRef } from "react";
import PropTypes from "prop-types";
import CalendarIcon from "/public/images/icons/calendar.svg?react";
import ErrorIcon from "/public/images/icons/inputError.svg?react";

export default function DatePicker({
  name,
  onChange,
  required,
  placeholder,
  label,
  error,
  className,
  ref,
  defaultValue,
  ...props
}) {
  const inputRef = useRef(null);

  return (
    <label className={`flex flex-col gap-1  ${className}`}>
      {label && (
        <div>
          <span className="text-sportsBlack font-medium text-base leading-[26px] mb-1">
            {label}
            {required && "*"}
          </span>
        </div>
      )}

      <div className="relative">
        <input
          type="date"
          placeholder={placeholder}
          name={name}
          defaultValue={defaultValue}
          onChange={onChange}
          ref={(el) => {
            inputRef.current = el;
            if (typeof ref === "function") ref(el);
            else if (ref) ref.current = el;
          }}
          step={"any"}
          required={required}
          {...props}
          className={`w-[175px] max-[410px]:w-[160px]
            ${error && "border-sportsRed !border-2"}
            focus:outline-sportsYellow
            bg-sportsLightGrey w-full border-solid border-[1px] border-[#E3E3E3] rounded-[4px] p-3 text-base leading-[26px] text-[#101820]
          `}
        />

        <span
          className={`${
            error ? "right-11" : "right-4"
          } absolute top-1/2 -translate-y-1/2 cursor-pointer z-20`}
          data-testid="calendar-icon"
          onClick={() => inputRef.current?.showPicker()}
        >
          <CalendarIcon className="w-6 h-6" />
        </span>

        {error && (
          <span 
            className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer z-20"
            data-testid="error-icon"
          >
            <ErrorIcon className="w-6 h-6" />
          </span>
        )}
      </div>

      {error && (
        <p className="text-sportsRed text-base leading-[24px]">{error}</p>
      )}
    </label>
  );
}

DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};